export default "__VITE_ASSET___8u457Md__"